module.exports = __webpack_public_path__ + "img/profile.55058049.svg";